import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './table__cell.scss';

const TableCell = (props) => {
    const { children, mix } = props;

    return <div className={cx('table__cell', mix)}>{children}</div>;
};

TableCell.propTypes = {
    children: PropTypes.node,
    mix: PropTypes.string,
};

export default TableCell;
